<template>
    <div class="card-price" :class="tagPos">
        <div v-if="tagName" class="card-price__tag">
            {{tagName}}
        </div>
        <div class="card-price__info">
            <span v-if="res.price < res.origPrice" class="original"><i>¥</i>{{res.origPrice}}</span>
            <template v-if="Number(res.price) === 0">
                <slot>
                    <span class="current">免费<span v-if="res.multi" class="multi">起</span></span>
                </slot>
            </template>
            <template v-else>
                <span class="current"><i>¥</i>{{res.price}}<span v-if="res.multi" class="multi">起</span></span>
            </template>
        </div>
    </div>
</template>

<script>
import {getPriceInfo} from '@base/util/price';

export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        },
        // tagPos: 'left'/'top' tag位置
        // penny: true/false 价格是否为分
        opts: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            res: {}
        };
    },
    computed: {
        tagName() {
            if (this.res.remainingTime) {
                return '限时优惠';
            }
            if (this.res.remainingCount) {
                return '限额优惠';
            }
            return '';
        },
        tagPos() {
            return this.opts.tagPos || 'top';
        },
        penny() {
            return this.opts.penny;
        }
    },
    watch: {
        info: {
            handler(val, oldVal) {
                this.res = getPriceInfo(val, {penny: this.penny});
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="less" scoped>
.card-price {
    display: flex;

    i {
        font-style: normal;
        text-align: center;
    }

    &.top {
        flex-direction: column;
        align-items: flex-end;

        .card-price__tag {
            margin-bottom: 5px;
        }
    }

    &.left {
        align-items: baseline;

        .card-price__tag {
            margin-right: 5px;
        }
    }

    &__tag {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 20px;
        font-size: 12px;
        font-weight: 400;
        color: #ff6e00;
        padding: 1px 2px;
        border-radius: 5px;
        background: #fff3e4;
    }

    .card-price__info {
        // 消除span之间的空档
        font-size: 0;
    }

    .original {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-decoration: line-through;
        color: #818a92;
        line-height: 12px;
        margin-right: 6px;

        i {
            display: inline-block;
            text-decoration: line-through;
        }
    }

    .current {
        font-size: 26px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 500;
        color: #f63232;
        line-height: 32px;
        height: 32px;

        i {
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
        }

        .multi {
            font-size: 22px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #ff382e;
            line-height: 26px;
            margin-left: 4px;
        }
    }

    .free-course-btn-wrapper {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;

        button {
            border-radius: 16px;
            border: 1px solid #d2d2d2;
            width: 80px;
            height: 32px;
        }

        .deactive {
            background: #fff;
            color: #333f4f;
        }

        .active {
            background: #f63232;
            color: #fff;
            border: none;
        }
    }
}
</style>
